import React, { useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

const CheckoutNavBar = (props: any) => {
  const history = useHistory();
  const { checkout, currentStep, goToStep } = props;

  useEffect(() => {
    if (history.location.hash === '#userDetails' && checkout.shippingMethod === null) {
      history.push('#shipping');
      goToStep(1);
    }
    if (history.location.hash === '#payment' && checkout.checkOutVerified === false) {
      history.push('#shipping');
      goToStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (step) => {
    if ((currentStep === 2 || currentStep === 3) && step === 1) {
      history.push('#shipping');
      goToStep(1);
    }
    if (step === 2 && checkout.shippingMethod !== null) {
      history.push('#userDetails');
      goToStep(2);
    }
    if (step === 3 && checkout.checkOutVerified !== false) {
      history.push('#payment');
      goToStep(3);
    }
  };

  return (
    <div className="text-center mt-3">
      <Breadcrumb tag="nav" listTag="div" style={{ display: 'inline-flex' }}>
        <BreadcrumbItem
          style={{ cursor: 'pointer', color: 'black' }}
          onClick={() => history.push('/cart')}
        >
          Cart
        </BreadcrumbItem>
        <BreadcrumbItem
          style={{ cursor: 'pointer', color: currentStep === 1 ? 'rgb(236,23,79)' : 'black' }}
          onClick={() => handleClick(1)}
        >
          Shipping
        </BreadcrumbItem>
        <BreadcrumbItem
          style={{ cursor: 'pointer', color: currentStep === 2 ? 'rgb(236,23,79)' : 'black' }}
          onClick={() => handleClick(2)}
        >
          Information
        </BreadcrumbItem>
        <BreadcrumbItem
          style={{ cursor: 'pointer', color: currentStep === 3 ? 'rgb(236,23,79)' : 'black' }}
          onClick={() => handleClick(3)}
        >
          Payment
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  checkout: state.checkout,
  shoppingCart: state.cart,
  guest: state.guest,
});

export default connect(mapStateToProps, {})(CheckoutNavBar);
